import Base from '@studiometa/js-toolkit/abstracts/Base';

/**
 * ImageZoom class
 *
 * @see https://github.com/malaman/js-image-zoom
 */
export default class ImageZoom extends Base {
  /**
   * Class config.
   * @return {Object}
   */
  get config() {
    return {
      name: 'ImageZoom',
    };
  }

  /**
   * Mounted Hook
   */
  mounted() {
    this.$refs.container.addEventListener('mousemove', this.zoom);
    this.$refs.container.addEventListener('touchmove', this.zoomTouch);
    this.$refs.container.addEventListener('mouseout', () => {
      this.$refs.img.style.opacity = 1;
    });
    this.$refs.container.addEventListener('touchend', () => {
      this.$refs.img.style.opacity = 1;
      document.body.style.overflow = '';
    });
  }

  /**
   * Zoom
   */
  zoom(e) {
    const zoomer = e.currentTarget;
    this.$refs.img.style.opacity = 0;
    const x = (e.offsetX / zoomer.offsetWidth) * 100;
    const y = (e.offsetY / zoomer.offsetHeight) * 100;
    zoomer.style.backgroundPosition = `${x}% ${y}%`;
  }

  /**
   * Zoom touch
   */
  zoomTouch(e) {
    document.body.style.overflow = 'hidden';
    const zoomer = e.currentTarget;
    this.$refs.img.style.opacity = 0;
    const x = (e.touches[0].pageX / zoomer.offsetWidth) * 100;
    const y = (e.touches[0].pageY / zoomer.offsetHeight) * 100;
    zoomer.style.backgroundPosition = `${x}% ${y}%`;
  }
}
